module.exports = __webpack_public_path__ + "img/FreelancerFeaturesSmartphone.df0de890.webp";